import useQuery from "../../utils/queryparam";
import {useEffect} from "react";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";


export default function CSMRedirectComponent({}) {
    let {loginCSM} = AuthenticationApiCalls();
    const query = useQuery();

    useEffect(() => {
        let secret = query.get("secret");
        let path = query.get("to");
        loginCSM(secret, path);
    }, []);
    return (<></>);
}